<app-navbar></app-navbar>

<div class="gestionar-productos-container">
  <h2>Productos del alojamiento {{ alojamientoName }}</h2>

  <!-- Botón para crear -->
  <button class="btn-primary" (click)="irACrearProducto()">
    + Crear producto
  </button>

  <!-- Tabla de productos -->
  <div *ngIf="cargando; else contenido">
    <p class="mensaje-cargando">Cargando productos...</p>
  </div>
  <ng-template #contenido>
    <table class="productos-table" *ngIf="productos.length > 0; else noProductos">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Cantidad</th>
          <th>Precio</th>
          <th style="width: 160px;">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let producto of productos">
          <td>{{ producto.name }}</td>
          <td>{{ producto.stock }}</td>
          <td>{{ producto.price }}</td>
          <td class="acciones">
            <button class="btn-small" (click)="editarProducto(producto)">✏️ Editar</button>
            <button class="btn-small btn-danger" (click)="abrirModalEliminar(producto)">🗑️ Eliminar</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Modal Eliminar -->
    <div class="modal-overlay" *ngIf="mostrarModalEliminar">
      <div class="modal">
        <h3>¿Eliminar este producto?</h3>

        <div class="producto-info">
          <p><strong>ID:</strong> {{ productoAEliminar?.productId }}</p>
          <p><strong>Nombre:</strong> {{ productoAEliminar?.name }}</p>
          <p><strong>Descripción:</strong> {{ productoAEliminar?.description }}</p>
          <p><strong>Precio:</strong> {{ productoAEliminar?.price | currency }}</p>
          <p><strong>Impuesto:</strong> {{ productoAEliminar?.tax_rate }}%</p>
          <p><strong>Stock:</strong> {{ productoAEliminar?.stock }}</p>
          <p><strong>Creado:</strong> {{ productoAEliminar?.created_at | date:'short' }}</p>
          <p><strong>Actualizado:</strong> {{ productoAEliminar?.updated_at | date:'short' }}</p>
        </div>

        <div class="modal-actions">
          <button class="btn-small btn-danger" (click)="confirmarEliminarProducto()">🗑️ Sí, eliminar</button>
          <button class="btn-small" (click)="cerrarModalEliminar()">Cancelar</button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Mensaje cuando no hay productos -->
  <ng-template #noProductos>
    <p class="mensaje-vacio">No hay productos cargados para este alojamiento.</p>
  </ng-template>
</div>

<app-footer></app-footer>
